export enum NotificationTypes {
  COMMON = 'common',
  CALL = 'call',
  MENTION = 'mention',
  OVERDUE_TO_DO = 'overdueToDo',
  /** Notify v2: to-do due today (morning reminder); old notifiers never send it */
  DUE_TO_DO = 'dueToDo',
  TO_DO_ASSIGNED = 'toDoAssigned',
  TO_DO_COMPLETED = 'toDoCompleted',
  ENTITY_ASSIGNED_TO_SUPERVISOR = 'employeeAssignedToSupervisor',
  SUPERVISED_ENTITY_DEACTIVATED = 'supervisedEntityDeactivated',
  WHATSAPP_MESSAGE_TEMPLATE_STATUS_UPDATE = 'whatsappMessageTemplateStatusUpdate',
  COURSE_CANCELLATION_FAILED = 'courseCancellationFailed',
  HANDOUT_EVENT_FEEDBACK = 'handoutEventFeedback',
  /** Morning reminder (Mon–Fri 07:30) about lessons whose course logs are missing; old notifiers never send it */
  MISSING_COURSE_LOGS = 'missingCourseLogs',
  /** Answer / state change of a takeover offer ("Dauerhafte Übernahme anbieten") for sender and Standort supervisor */
  TAKEOVER_OFFER_UPDATE = 'takeoverOfferUpdate',
  /** QM-Cockpit: summary of new rescue / group cases ("3 neue Rückgewinnungen, 1 Gruppenfall"); old notifiers never send it */
  QUALITY_CASE_DIGEST = 'qualityCaseDigest',
  /** Lehrkraft-Bereich: Ausfall gemeldet ("Ich bin krank") / zugesagte Vertretung zurückgezogen – Büro + QM-Person; old notifiers never send it */
  TEACHER_SICK_REPORT = 'teacherSickReport',
  /** Bewerbungs-Bereich: an applicant withdrew the application (with planning conflicts); old notifiers never send it */
  APPLICATION_WITHDRAWN = 'applicationWithdrawn',
  /** Löschantrag (DSGVO) aus dem Bewerbungs-Bereich: Selbstlöschung wegen Vertrag / Abrechnung / Kurs / Rechnung nicht möglich */
  APPLICANT_DELETION_REQUESTED = 'applicantDeletionRequested',
  /** Versand: Stand einer DHL-Abholung geändert – an die Person, die gebucht hat; old notifiers never send it */
  DHL_PICKUP_UPDATE = 'dhlPickupUpdate',
}
